import { BoxProps, Flex, Icon } from '@chakra-ui/react';
import { FC } from 'react';

import DocumentIcon from '@/assets/icons/ic-document.svg';

import { OmnisearchOccurrencePreview } from '@/components/ui/features/lecture/LectureOmnisearch/components/OmnisearchOccurrencePreview';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { IPosterDocumentOccurrence } from '@/resources/OmnisearchOccurrence';

interface IOmnisearchPosterOccurrence extends BoxProps {
  context: Array<IPosterDocumentOccurrence>;
  occurrenceIndex: number;
}
export const OmnisearchOccurrencePoster: FC<IOmnisearchPosterOccurrence> = ({ context, occurrenceIndex, ...rest }) => {
  const { query, change } = useQueryParams<{ query: string; posterExpanded: string; index: string; t: string }>({
    query: StringParam,
    index: StringParam,
    posterExpanded: StringParam,
    t: StringParam,
  });

  function goToOccurrence() {
    change(
      { posterExpanded: 'true', query, index: occurrenceIndex.toString(), t: null },
      { method: 'replace', shallow: true }
    );
  }

  return (
    <Flex _hover={{ cursor: 'pointer' }} onClick={goToOccurrence} color="black" bgColor="white" p="1" {...rest}>
      <Icon mr="1" as={DocumentIcon} w="24px" h="24px" />
      <OmnisearchOccurrencePreview context={context} />
    </Flex>
  );
};
